import { render, staticRenderFns } from "./ResellerClientDatabase.vue?vue&type=template&id=72fcce95&scoped=true&"
import script from "./ResellerClientDatabase.vue?vue&type=script&lang=js&"
export * from "./ResellerClientDatabase.vue?vue&type=script&lang=js&"
import style0 from "./ResellerClientDatabase.vue?vue&type=style&index=0&id=72fcce95&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fcce95",
  null
  
)

export default component.exports